import React, { ReactNode } from 'react';
import Footer from '../components/Footer';

interface BlogLayoutProps {
  children: ReactNode;
  maxWidth?: 'narrow' | 'normal' | 'wide';
}

export const BlogLayout: React.FC<BlogLayoutProps> = ({ 
  children, 
  maxWidth = 'normal' 
}) => {
  const widthClasses = {
    narrow: 'max-w-3xl',
    normal: 'max-w-5xl',
    wide: 'max-w-7xl',
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-gray-950 dark:via-gray-950 dark:to-gray-950">
      <main className="flex-1 overflow-x-hidden">
        <div className={`container mx-auto px-4 py-8 ${widthClasses[maxWidth]}`}>
          {children}
        </div>
      </main>
      
      <Footer />
    </div>
  );
};
